import React from "react";

const TermsAndConditions = () => {
  return (
    <div style={{ maxWidth: "800px", margin: "60px auto", padding: "0 24px", fontFamily: "Syne, sans-serif", color: "#1a2e1a", lineHeight: 1.8 }}>
      <h1 style={{ fontSize: "28px", fontWeight: 600, marginBottom: "8px" }}>Terms & Conditions</h1>
      <p style={{ color: "#666", fontSize: "13px", marginBottom: "32px" }}>Last updated: April 2026</p>

      <section style={{ marginBottom: "32px" }}>
        <h2 style={{ fontSize: "18px", fontWeight: 600, marginBottom: "12px" }}>Acceptance of Terms</h2>
        <p>By accessing or using the ProMed Health Plus platform at <a href="https://promedhealthplus.com" style={{ color: "#4E8A3C" }}>https://promedhealthplus.com</a>, you agree to be bound by these Terms & Conditions. If you do not agree, please do not use our platform.</p>
      </section>

      <section style={{ marginBottom: "32px" }}>
        <h2 style={{ fontSize: "18px", fontWeight: 600, marginBottom: "12px" }}>SMS Terms</h2>
        <p>By providing your phone number and using our platform, you consent to receive SMS messages from ProMed Health Plus including:</p>
        <ul style={{ paddingLeft: "24px", marginTop: "8px" }}>
          <li>Login verification codes (MFA)</li>
          <li>Order status and shipping alerts</li>
          <li>Account notifications</li>
          <li>Appointment reminders</li>
        </ul>
        <ul style={{ paddingLeft: "24px", marginTop: "16px", listStyle: "none" }}>
          <li>• Messaging frequency may vary.</li>
          <li>• Message and data rates may apply.</li>
          <li>• To opt out at any time, text <strong>STOP</strong>.</li>
          <li>• For assistance, text <strong>HELP</strong> or visit <a href="https://promedhealthplus.com" style={{ color: "#4E8A3C" }}>https://promedhealthplus.com</a>.</li>
          <li>• Visit <a href="https://promedhealthplus.com/privacy-policy" style={{ color: "#4E8A3C" }}>https://promedhealthplus.com/privacy-policy</a> for our Privacy Policy.</li>
          <li>• Visit <a href="https://promedhealthplus.com/terms" style={{ color: "#4E8A3C" }}>https://promedhealthplus.com/terms</a> for Terms of Service.</li>
        </ul>
      </section>

      <section style={{ marginBottom: "32px" }}>
        <h2 style={{ fontSize: "18px", fontWeight: 600, marginBottom: "12px" }}>Platform Use</h2>
        <p>ProMed Health Plus is a B2B platform for licensed healthcare providers. Access is restricted to verified providers, sales representatives, and authorized administrators. Unauthorized use is strictly prohibited.</p>
      </section>

      <section style={{ marginBottom: "32px" }}>
        <h2 style={{ fontSize: "18px", fontWeight: 600, marginBottom: "12px" }}>Limitation of Liability</h2>
        <p>ProMed Health Plus LLC shall not be liable for any indirect, incidental, or consequential damages arising from the use of our platform. Our liability is limited to the maximum extent permitted by applicable law.</p>
      </section>

      <section style={{ marginBottom: "32px" }}>
        <h2 style={{ fontSize: "18px", fontWeight: 600, marginBottom: "12px" }}>Contact</h2>
        <p>For questions about these terms, contact us at <a href="mailto:portal@promedhealthplus.com" style={{ color: "#4E8A3C" }}>portal@promedhealthplus.com</a>.</p>
      </section>
    </div>
  );
};

export default TermsAndConditions;